export class Addon {

    constructor (title, additives, price=0) {
        this._title = title
        this._additives = additives
        this._price = price
    }

    get additives () {
        return this._additives
    }

    get title () {
        return this._title
    }

    get price () {
        return this._price
    }
}










